import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PARTNER_UPDATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_meeting_invites = (data) => {


    var queryString = '';
    if (data.status) {
        queryString = data.status.map((item) => `status=${item}`).join('&');
    } else {
        queryString = `status=`
    }

    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/partner/invites?${queryString}`, config)
                .then(response => {
                    dispatch({
                        type: PARTNER_UPDATE,
                        payload: {
                            meetingInvites: response.data,
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    })
                })
                .catch(error => {
                    dispatch({
                        type: PARTNER_UPDATE,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })
                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_meeting_invites;
